const question = {
    state: {
        artical: {}
    },
    getters: {

    },
    mutations: {
        changeArtical(state,obj) {
            state.artical = obj;
        }
    },
    actions: {
        handleChangeArtical({commit},id) {
            let artical = {};
            switch (id) {
                case 1: 
                artical = {
                    id: 1,
                    title: '什么是ETC',
                    content: `ETC（Electronic Toll Collection），
                    中文翻译是电子不停车收费系统，是高速公路或桥梁自动收费。
                    通过安装在车辆挡风玻璃上的车载电子标签与在收费站ETC车道上的微波天线之间进行的专用短程通讯。
                    利用计算机联网技术与银行进行后台结算处理，
                    从而达到车辆通过高速公路或桥梁收费站无需停车而能交纳高速公路或桥梁费用的目的。`,
                    // prevTitle: '',
                    // nextTitle: '什么是记账卡',
                }
                break;
                case 2: 
                artical = {
                    id: 2,
                    title: '什么是记账卡',
                    content: `记账卡就是“先通行后扣费”的高速ETC通行卡，用户通过高速公路缴费站时，
                    暂时不用交费，电脑记录通行情况，系统将自动、分次从授权账户划扣客户名下记账卡相关费用。
                    每个记账卡都必须和某个银行卡账户相关，用户要保证银行账户中有足够的金额以支付通行费用，
                    否则记账卡会被停止使用。`,
                    // prevTitle: '工作时间',
                    // nextTitle: '办理资料拍照格式',
                }
                break;
                case 3: 
                artical = {
                    id: 3,
                    title: '办理资料拍照格式',
                    content: `【人车资料】：身份证正反面照片、行驶证正副本照片、车头照片。
                    【以上照片格式要求】：证件四周要留白、不要缺角、不要折叠，不要手持拍照，
                    背景尽量干净整洁，这样系统录入通过率才会高，资料不合格需要重新上传审核资料。`,
                    // prevTitle: '什么是',
                    // nextTitle: '是否全国折扣',
                }
                break;
                case 4: 
                artical = {
                    id: 4,
                    title: '是否全国折扣',
                    content: `交通运输部办公厅印发《关于大力推动高速公路ETC发展应用工作的通知》中明确，将加大ETC车辆通行优惠力度。
                    从2019年7月1日起，严格落实对ETC用户不少于5%的车辆通行基本优惠政策，并实现对通行本区域的ETC车辆无差别基本优惠，
                    即全国ETC统一享受不少于5%的折扣政策。`,
                    // prevTitle: '关于办理资料拍照格式说明',
                    // nextTitle: '记账卡如何办理，支持绑定哪几家银行信用卡',
                }
                break;
                case 5: 
                artical = {
                    id: 5,
                    title: '设备需要充电吗',
                    content: `由于ETC设备是太阳能供电的，所有无需外接电源充电。`,
                    // prevTitle: '什么是记账卡',
                    // nextTitle: '什么是储值卡',
                }
                break;
                case 6: 
                artical = {
                    id: 6,
                    title: '设备全国通用吗',
                    content: `可以，根据交通部相关规定，2015年ETC全国联网以后，所有ETC设备全国高速通用。`,
                    // prevTitle: '记账卡如何办理，支持绑定哪几家银行信用卡',
                    // nextTitle: '储值卡如何办理',
                }
                break;
                case 7: 
                artical = {
                    id: 7,
                    title: '已经办理过ETC怎么办',
                    content: `由于交通部规定一辆车只能办理一台ETC设备，
                    所以您需要联系当时办理网点，注销旧设备以后才能重新办理，
                    我们这边也可以提供注销服务，注销费用需根据发行省份收取。`,
                    // prevTitle: '什么是储值卡',
                    // nextTitle: '关于退款',
                }
                break;
                case 8: 
                artical = {
                    id: 8,
                    title: '会被盗刷吗',
                    content: `ETC卡片仅能用于通行ETC车道计费使用，不具有银行卡功能，所以不存在盗刷风险。`,
                    // prevTitle: '储值卡如何办理',
                    // nextTitle: '',
                }
                break;
                case 9: 
                artical = {
                    id: 9,
                    title: '工作时间',
                    content: `电话客服：上午9:00-12:00 下午13:30-18:00
                    支付宝云客服：上午9:00-12:00 下午13:30-18:00`,
                    // prevTitle: '',
                    // nextTitle: '什么是记账卡',
                }
                break;
                case 10: 
                artical = {
                    id: 10,
                    title: '关于发货',
                    content: `记账卡用户在绑卡成功后3个工作日左右发出，非
                    人为因素（系统升级、断电等不可抗因素）以客服
                    咨询为准。</p>`,
                    // prevTitle: '',
                    // nextTitle: '什么是记账卡',
                }
                break;
                default: 
                // artical = {
                //     id: 1,
                //     title: '什么是ETC',
                //     content: `ETC（Electronic Toll Collection），
                //     中文翻译是电子不停车收费系统，是高速公路或桥梁自动收费。
                //     通过安装在车辆挡风玻璃上的车载电子标签与在收费站ETC车道上的微波天线之间进行的专用短程通讯。
                //     利用计算机联网技术与银行进行后台结算处理，
                //     从而达到车辆通过高速公路或桥梁收费站无需停车而能交纳高速公路或桥梁费用的目的。`,
                //     // prevTitle: '',
                //     // nextTitle: '什么是记账卡',
                // }
            }
            commit('changeArtical',artical);
        }

    }
}
export default question;


// WEBPACK FOOTER //
// ./src/store/module/question.js